export default __webpack_public_path__ + "static/media/pyesu_stop.2c0c9a37.svg";